import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

export const root = css`
  display: inline-flex;
  align-items: center;
  color: var(${themeVariables.colors.content.brand});
  font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});

  svg {
    display: inline-block;
    margin-right: var(${themeVariables.spacing.xxs});
    vertical-align: text-bottom;
  }
`;

export const muted = css`
  color: var(${themeVariables.colors.content.secondary});
`;
